
import { gql } from "@apollo/client";

/* ************************************************
 * STORE_TYPE Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-09-02 17:27:07 using DbdbTap
 ************************************************ */

const STORE_TYPE_LIST_PART = gql`
fragment StoreTypeListPart on StoreType {
    storeTypeCd
    storeTypeName
    storePrefix
    storePostfix
    codeThree
    expressStore
    iconPath
    fontColor
    backColor
    viewLevel
    flagOne
    flagTwo
    regDate
    regUser
}
`;


export const LIST_STORE_TYPE = gql`
${STORE_TYPE_LIST_PART}
query ListStoreType {
    storeTypeList {
        ...StoreTypeListPart
    }
}
`;

export const GET_STORE_TYPE = gql`
${STORE_TYPE_LIST_PART}
query GetStoreType($storeTypeCd:String!) {
    storeTypeItem(storeTypeCd:$storeTypeCd) {
        ...StoreTypeListPart
    }
}
`;
